<div [formGroup]="contractForm">
  @if (employeeId()) {
    @if (contractForm.controls.contractType.value === 'CDI') {
      <mat-checkbox
        [formControl]="renewalControl"
        (change)="updateTrialPeriodEnability()"
        [disabled]="readOnly()"
        >Le salarié est déjà présent dans le cadre d'un autre contrat de travail sans rupture
        intermédiaire</mat-checkbox
      >
    }
    @if (contractForm.controls.contractType.value !== 'CDI') {
      <mat-checkbox
        [formControl]="renewalControl"
        (change)="updateTrialPeriodEnability()"
        [disabled]="readOnly()"
        >Le salarié fait l'objet d'une prolongation</mat-checkbox
      >
    }
    @if (renewalControl.value) {
      <div>
        <app-select-most-recent-contract
          [excludeContractId]="contractForm.controls.id.value"
          [employeeId]="employeeId()!"
          [startDate]="contractForm.controls.startDate.value"
          [value]="contractForm.controls.previousContractId.value"
          (contractSelected)="onPreviousContractSelected($event)"
          [required]="validation()"
          [disabled]="readOnly()"
          [openOnly]="true"
        >
        </app-select-most-recent-contract>
      </div>
    }
  }
  <app-select-company
    [formControl]="companyId"
    [required]="validation()"
    [openOnly]="true"
    [class.hidden]="renewalControl.value"
  ></app-select-company>

  <app-select-contract-type
    [formControl]="contractForm.controls.contractType"
    (selectionChange)="onContractTypeChange($event)"
    [required]="validation()"
  ></app-select-contract-type>
  @if (employeeId() && overlappingContracts.length > 0) {
    <app-warn-tips> L’employé est déjà en cours de contrat sur la même période. </app-warn-tips>
  }
  <div class="flex gap wrap">
    <mat-form-field class="w-100">
      <mat-label>Date de début</mat-label>
      <input
        matInput
        [matDatepicker]="startPicker"
        formControlName="startDate"
        [required]="validation()"
        (change)="ensureSalaryScaleUpToDateAndRefreshMinSalary()"
      />
      <mat-hint>JJ/MM/AAAA</mat-hint>
      <mat-datepicker-toggle matIconPrefix [for]="startPicker"></mat-datepicker-toggle>
      <mat-datepicker
        #startPicker
        (closed)="ensureSalaryScaleUpToDateAndRefreshMinSalary()"
      ></mat-datepicker>
    </mat-form-field>

    @if (showDateDeFin) {
      <mat-form-field class="w-100">
        @if (contractForm.controls.contractType.value === 'CDD R') {
          <mat-label>Date de fin minimale (incluse)</mat-label>
        } @else {
          <mat-label>Date de fin (incluse)</mat-label>
        }
        <input
          matInput
          [matDatepicker]="endPicker"
          formControlName="endDate"
          [required]="validation()"
        />
        <mat-hint>JJ/MM/AAAA</mat-hint>
        <mat-datepicker-toggle matIconPrefix [for]="endPicker"></mat-datepicker-toggle>
        <mat-datepicker #endPicker></mat-datepicker>
        @if (contractForm.hasError('startEndDateRange')) {
          <mat-error>La date de fin doit être postérieure ou égale à la date de début.</mat-error>
        }
      </mat-form-field>
    }
  </div>
  <div class="flex gap wrap">
    <app-select-job-type
      [formControl]="contractForm.controls.jobId"
      (selectionChange)="ensureSalaryScaleUpToDateAndRefreshMinSalary()"
      [required]="validation()"
      class="w-100"
    ></app-select-job-type>
    <app-select-qualification-level
      [formControl]="contractForm.controls.qualificationLevel"
      [jobId]="contractForm.controls.jobId.value"
      (selectionChange)="updateGrossHourlySalary()"
      [required]="validation()"
      class="w-100"
    ></app-select-qualification-level>
    <mat-form-field class="w-100" [class.gross-hourly-salary-updated]="grossHourlySalaryUpdated">
      <mat-label>Salaire horaire brut</mat-label>
      <input
        matInput
        formControlName="grossHourlySalary"
        type="number"
        step="0.01"
        [required]="validation()"
      />
      <span matTextSuffix>€</span>
      <mat-hint
        [class.warning]="minGrossHourlySalary !== contractForm.controls.grossHourlySalary.value"
      >
        @if (updatedBySalaryScale) {
          <span class="warning">MAJ par application de la convention collective</span>
          <br />
        }
        Minimum : {{ minGrossHourlySalary | currency: 'EUR' : 'symbol' : '1.2-2' }}
      </mat-hint>
    </mat-form-field>
  </div>

  @if (contractDuration) {
    <app-label-value
      class="w-100"
      label="Durée du contrat"
      [value]="contractDuration"
    ></app-label-value>
  }

  <section>
    <h3>Période d'essai</h3>
    <div class="flex gap trial-period">
      @if (trialPeriodDurationInDays !== null) {
        <div class="w-100 contract-duration">
          <app-label-value
            class="w-100"
            label="Fin de la période d'essai"
            [value]="contractForm.controls.endOfFirstTrialPeriodDate.value | date: 'dd/MM/yyyy'"
            matTooltip="Date de fin incluse dans la période d'essai"
          ></app-label-value>
          <app-label-value
            class="w-100"
            label="Durée de la période d'essai"
            [value]="trialPeriodDurationInDays + ' jours'"
          ></app-label-value>
          @if (contractForm.hasError('startEndOfFirstTrialPeriodDateRange')) {
            <mat-error
              >La date de fin de période d'essai doit être postérieure ou égale à la date de
              début.</mat-error
            >
          }
        </div>
      } @else {
        <app-label-value class="w-100" label="Période d'essai" value="Aucune"></app-label-value>
      }
    </div>
  </section>

  @if (isReplacement) {
    <ng-container [formGroup]="replacementForm">
      <h3>Remplacement</h3>
      <div class="flex gap">
        <mat-radio-group
          formControlName="civility"
          class="w-100 employee-title"
          [required]="validation()"
        >
          <mat-label>Civilité</mat-label>
          @for (title of PersonTitles; track $index) {
            <mat-radio-button [value]="title">{{ title }}</mat-radio-button>
          }
        </mat-radio-group>
      </div>
      <div class="flex gap wrap">
        <mat-form-field class="w-100">
          <mat-label>Nom</mat-label>
          <input matInput formControlName="lastName" appToUppercase [required]="validation()" />
        </mat-form-field>
        <mat-form-field class="w-100">
          <mat-label>Prénom</mat-label>
          <input matInput formControlName="firstName" appTitlecase [required]="validation()" />
        </mat-form-field>
      </div>
      <div class="flex gap">
        <app-select-job-type
          class="w-100"
          [formControl]="replacementForm.controls.jobId"
          [disabled]="readOnly()"
        ></app-select-job-type>
        <app-select-qualification-level
          class="w-100"
          [formControl]="replacementForm.controls.qualificationLevel"
          [jobId]="replacementForm.controls.jobId.value || null"
        ></app-select-qualification-level>
      </div>
      <app-select-replacement-reason
        label="Motif de remplacement"
        formControlName="reason"
        [required]="validation()"
      ></app-select-replacement-reason>
    </ng-container>
  }

  <div class="flex gap">
    <mat-checkbox matSuffix formControlName="companyCar">Véhicule de société</mat-checkbox>
  </div>
</div>
